import toast, { ToastBar, Toaster } from 'react-hot-toast';
import { ProviderBase } from './providers';

const App = () => {
  return (
    <div className="app-wrapper">
      <ProviderBase />

      <Toaster
        toastOptions={{
          error: {
            duration: Infinity,
          },
          success: {
            duration: 4000,
          },
        }}
      >
        {t => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'success' && <button onClick={() => toast.dismiss(t.id)}>X</button>}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
};

export default App;
